import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { HttpModule } from '@angular/http';
import { Ng2ImgToolsModule } from 'ng2-img-tools';

@NgModule({
    declarations: [
        HomeComponent
    ],
    imports: [
        HomeRoutingModule,
        CommonModule,
	HttpModule,
	Ng2ImgToolsModule
    ],
    exports: [
        HomeComponent
    ]
})
export class HomeModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src?loader=system&genDir=src&aot=false!./~/tslint-loader!./src/app/home/home.module.ts